import { ar, enUS, fr, hi } from 'date-fns/locale'
import type { Locale } from 'date-fns'

/**
 * The date-fns locale a <Calendar> draws its month and weekday names in, per
 * interface language (docs/LOCALE.md). Shared by the date-time and date-range
 * pickers so neither shows English weekdays to an Arabic, Hindi or French admin.
 */
const CALENDAR_LOCALES = { en: enUS, ar, fr, hi } as const

export function calendarLocaleFor(locale: string): Locale {
  return CALENDAR_LOCALES[locale as keyof typeof CALENDAR_LOCALES] ?? enUS
}
